import { BaseApi } from './base';

class AuthApi extends BaseApi {
  constructor() {
    super('auth');
  }

  getUser() {
    return this.get('/user');
  }

  logIn(signInData) {
    return this.post('/login', signInData);
  }

  signUp(signUpData) {
    return this.post('/register', signUpData);
  }

  logOut() {
    return this.post('/logout');
  }

  getUsers() {
    return this.get('/users');
  }

  registerTeacher(data) {
    return this.post('/teacher', data);
  }

  changeUserName(data) {
    // If data is FormData, let axios handle Content-Type automatically
    const config = data instanceof FormData ? {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    } : {};

    return this.post('/change-name', data, config);
  }

  changeUserPassword(data) {
    return this.post('/change-password', data);
  }

  sendResetRequest(email) {
    return this.post('/link', { email });
  }
}

export default new AuthApi();
